import lightGrayButtonRule from '../../../light-gray/background/default/primary';

const custom = (params) => lightGrayButtonRule(params);

export default custom;
